import type { QuickInterviewPhase } from "./VoiceConversationStatus";

const VIDEOS = {
  idle: "/videos/interviewer/idle.mp4",
  speaking: "/videos/interviewer/speaking.mp4",
  listening: "/videos/interviewer/nodding.mp4",
  thinking: "/videos/interviewer/thinking.mp4",
} as const;

/**
 * 表示する映像を決める（#1728）。
 *
 * nodWhileListening が false のときは、応募者が話している間もうなずかず静止する。
 * 厳しめの面接官は言葉の相槌を禁じているのに、映像だけ終始うなずいていると
 * 相反するシグナルを同時に出すことになり、非言語のほうが受け手の印象を決めてしまう。
 */
function activeVideo(phase: QuickInterviewPhase, nodWhileListening: boolean) {
  if (phase === "interviewer_speaking") return "speaking";
  if (phase === "candidate_speaking") return nodWhileListening ? "listening" : "idle";
  if (phase === "ending") return "thinking";
  return "idle";
}

export default function InterviewerVideoPanel({
  phase,
  showLabel = true,
  sizeClassName = "aspect-[4/3] min-h-[280px] sm:aspect-video",
  nodWhileListening = true,
}: {
  phase: QuickInterviewPhase;
  showLabel?: boolean;
  sizeClassName?: string;
  /** 応募者が話している間にうなずくか。厳しめの面接官では false にする（#1728）。 */
  nodWhileListening?: boolean;
}) {
  const active = activeVideo(phase, nodWhileListening);

  return (
    <div className={`relative overflow-hidden bg-black ${sizeClassName}`}>
      {Object.entries(VIDEOS).map(([name, src]) => (
        <video
          key={name}
          src={src}
          data-video-state={name}
          data-active={name === active ? "true" : "false"}
          className={`absolute inset-0 size-full object-cover transition-opacity duration-150 ${
            name === active ? "opacity-100" : "pointer-events-none opacity-0"
          }`}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          aria-hidden={name !== active}
        />
      ))}
      {showLabel && (
        <div className="absolute left-4 top-4 flex items-center gap-2 rounded-md bg-black/70 px-3 py-2 text-sm font-bold text-white">
          <span className="size-2 rounded-full bg-success" />
          面接官
        </div>
      )}
    </div>
  );
}
